// extracted by css-extract-rspack-plugin
export default {"chartContainer":"chart-container--hj5TIK4JxbwxNo6x"};